export default __webpack_public_path__ + "static/media/PersonCar.1375fd30.svg";